


















































import { arrayFilter } from '@noeldemartin/utils';
import Vue from 'vue';

import ErrorInfoModal from '@/components/modals/ErrorInfoModal.vue';
import SolidAuth from '@/authentication/SolidAuth';

interface Data {
    forbidden: boolean;
}

interface Action {
    label: string;
    url?: string;
    handle?: Function;
}

export default Vue.extend({
    data: (): Data => ({ forbidden: false }),
    computed: {
        actions(): Action[] {
            const githubIssueTitle = 'Login unauthorized';
            const githubIssueBody = 'Please explain how you tried to log in when the error occurred.';

            return arrayFilter([
                this.forbidden && {
                    label: 'Try again',
                    handle: () => this.refreshCredentials(),
                },
                this.forbidden && {
                    label: 'Get help',
                    url: `${this.$app.sourceUrl}/issues/new?title=${githubIssueTitle}&body=${githubIssueBody}`,
                },
                this.$auth.unauthorizedError && {
                    label: this.forbidden ? 'View error details' : 'View details',
                    handle: () => this.$ui.openModal(ErrorInfoModal, { error: this.$auth.unauthorizedError }),
                },
                {
                    label: 'Logout',
                    handle: () => this.$auth.logout(),
                },
            ]);
        },
    },
    created() {
        if (this.$auth.isLoggedIn() && this.$media.loaded)
            this.$router.replace({ name: 'home' });

        if (SolidAuth.previousLogin === null)
            this.$router.replace({ name: 'login' });

        this.forbidden = !!this.$route.query.forbidden;
    },
    methods: {
        async refreshCredentials() {
            const loginUrl =  SolidAuth.previousLogin!.loginUrl;
            const authenticator = SolidAuth.previousLogin!.authenticationMethod;

            try {
                this.$auth.setRefreshing(true);

                await this.$auth.user?.logout();
                await this.$auth.loginWithSolid(loginUrl, authenticator);
            } catch (error) {
                this.$auth.setRefreshing(false);
                this.$ui.showError(error);
            }
        },
    },
});
